import Wait from "./Wait.js";
import { getAirportOpenTime, SCHEDULE_TYPES } from "../../assets/virtual-flyout/airport-service.js";

export default class WaitFuelOpen extends Wait {
    constructor(planeId, airport) {
        super(planeId, null, 'fuel open');
        this.airport = airport;
    }

    execute() {
        const simState = this.getSimState();
        const airportOpenTime = getAirportOpenTime(this.airport.code, SCHEDULE_TYPES.FUEL, simState.time);
        if (airportOpenTime) {
            this.time = airportOpenTime;
            super.execute();
        } 
    }
    
}